// extracted by css-extract-rspack-plugin
export default {"pin":"pin--goVvOsxN8Q0CS9Fs"};